module.exports = __webpack_public_path__ + "static/media/linkedin.501766b5.svg";